import { render, staticRenderFns } from "./consentCollection.vue?vue&type=template&id=27b0ba80&scoped=true"
import script from "./consentCollection.vue?vue&type=script&lang=js"
export * from "./consentCollection.vue?vue&type=script&lang=js"
import style0 from "./consentCollection.vue?vue&type=style&index=0&id=27b0ba80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b0ba80",
  null
  
)

export default component.exports